import { List, ListItem, ListItemText, Skeleton } from '@mui/material';

import { DefaultSkeletonProps } from './DefaultSkeleton.interface';

export default function DefaultSkeleton({ items = 8, single }: DefaultSkeletonProps) {
    const skeletonItems = Array.from({ length: items }, (_, index) => ({ id: index }));

    return (
        <List sx={{ paddingX: 3, paddingY: 4 }}>
            {skeletonItems.map((item) => (
                <ListItem key={item.id} divider sx={{ '&:first-of-type': { paddingTop: 0 } }}>
                    <ListItemText
                        primary={<Skeleton variant="text" width={single ? '80%' : '30%'} />}
                        secondary={
                            single ? undefined : (
                                <>
                                    <Skeleton
                                        variant="text"
                                        sx={{
                                            marginTop: 1,
                                        }}
                                    />
                                    <Skeleton variant="text" width="80%" />
                                </>
                            )
                        }
                    />
                </ListItem>
            ))}
        </List>
    );
}
